import "./new-transaction.scss";

import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import { Stepper, StepperChangeEvent } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import FormTransactionAddonWrapper from "@domain/transaction-addon/form-transaction-addon-wrapper/form-transaction-addon-wrapper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currencyFormat } from "@shared/utility/formats/currency-format";
import { useTransactionStepContext } from "./transaction-step.context";
import ServicePanel from "./service-panel/service-panel";
import { useNewTransactionContext } from "./new-transaction.context";
import TransactionSummary from "./transaction-summary/transaction-summary";
import NewTransactionWaiver from "@domain/transaction-waiver/new-transaction-waiver/new-transaction-waiver";
import PrintWaiver from "@domain/transaction-waiver/print-waiver/print-waiver";
import TransactionChildFirst from "./transaction-child-first/transaction-child-first";

import TransactionMember from "./transaction-member/transaction-member";
import TransactionChildren from "./transaction-children/transaction-children";
import TransactionParent from "./transaction-parent/transaction-parent";

export function NewTransaction() {
  const { componentRef, navigate } = useNewTransactionContext();
  const {
    stepperRef,
    isParentAndChild,
    addonFormData,
    addonTransactionRef,
    signaturePreview,
    selectedWaiverPreview,
    nextStepper,
    previousStepper,
    handleAddonTrigger,
    handleAddonForm,
    activeStep,
    setActiveStep,
  } = useTransactionStepContext();

  // LOCAL FUNCTION
  const handleAddonNext = () => {
    if (addonTransactionRef.current) {
      const values = addonTransactionRef.current.getValues();
      if (values.item && values.quantity && values.amount && values.itemData) {
        handleAddonForm(values);
      }
    }
    nextStepper();
  };

  // HTML
  const printSection = (
    <div style={{ display: "none" }}>
      <div ref={componentRef}>
        {selectedWaiverPreview ? (
          <PrintWaiver
            waiver={selectedWaiverPreview}
            signature={signaturePreview}
          />
        ) : null}
      </div>
    </div>
  );

  const servicePanel = (
    <StepperPanel key="service" header="Service">
      <ServicePanel />
    </StepperPanel>
  );
  const childFirstPanel = (
    <StepperPanel key="child-first" header="Child">
      <TransactionChildFirst />
    </StepperPanel>
  );  
  const parentPanel = (
    <StepperPanel key="parent" header="Guardian">
      <TransactionParent />
    </StepperPanel>
  );
  const childrenPanel = (
    <StepperPanel key="chidren" header="Children">
      <TransactionChildren />
    </StepperPanel>
  );
  const memberPanel = (
    <StepperPanel key="member" header="Member">
      <TransactionMember
        contextType="transaction"
        {...useNewTransactionContext}
      />
    </StepperPanel>
  );
  const waiverPanel = (
    <StepperPanel key="waiver" header="Waiver">
      <NewTransactionWaiver />
    </StepperPanel>
  );
  const addonPanel = (
    <StepperPanel key="addon" header="Addon">
      <div className="flex flex-col h-12rem">
        <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
          <FormTransactionAddonWrapper
            ref={addonTransactionRef}
            onSubmit={handleAddonForm}
          />

          <div>
            <small className="block mt-4">Selected Addons</small>
            <DataTable value={addonFormData}>
              <Column
                body={(cell) => <div>{cell.itemData?.name}</div>}
                header="Name"
              ></Column>
              <Column
                body={(cell) => currencyFormat(cell.itemData?.amount || 0)}
                header="Price"
              ></Column>
              <Column field="quantity" header="Quantity"></Column>
              <Column
                body={(cell) => currencyFormat(cell.amount || 0)}
                field="amount"
                header="Amount"
              ></Column>
            </DataTable>
          </div>
        </section>
      </div>
      <div className="flex pt-4 justify-between">
        <section className="flex gap-2">
          <Button
            label="Back"
            severity="success"
            outlined
            icon="pi pi-arrow-left"
            onClick={() => previousStepper()}
          />
          <Button
            label="Add Addon"
            icon="pi pi-plus"
            iconPos="right"
            outlined
            onClick={handleAddonTrigger}
          />
        </section>
        <Button
          label="Next"
          icon="pi pi-arrow-right"
          iconPos="right"
          onClick={handleAddonNext}
        />
      </div>
    </StepperPanel>
  );
  const summaryPanel = (
    <StepperPanel key="summary" header="Summary">
      <TransactionSummary />
    </StepperPanel>
  );

  const getStepperPanels = () => {
    if (isParentAndChild) {
      return [
        childFirstPanel,
        parentPanel,
        // childrenPanel,
        servicePanel,
        addonPanel,
        waiverPanel,
        summaryPanel,
      ];
    } else {
      return [memberPanel, servicePanel, addonPanel, waiverPanel, summaryPanel];
    }
  };

  return (
    <div id="NewTransaction" className="transaction">
      <HeaderContent
        title="New Booking"
        backIcon={<FaChevronLeft />}
        onBack={() => {
          if (activeStep > 0) {
            previousStepper();
          } else {
            navigate("../");
          }
        }}
      ></HeaderContent>
      {printSection}
      <div className="p-7">
        <section className="grid grid-cols-1 gap-2 mb-4">
          <Stepper
            ref={stepperRef}
            linear={true}
            activeStep={activeStep}
            onChangeStep={(e: StepperChangeEvent) => setActiveStep(e.index)}
          >
            {getStepperPanels()}
          </Stepper>
        </section>
      </div>
    </div>
  );
}

export default NewTransaction;
